import React from 'react';
import {connect} from 'react-redux';
import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';
import {Link} from 'react-router';

class RegisterBetaPage extends React.Component {
    render() {
        return <FullWidthPage title="Регистрация">
            <form className="profile-form login" method="post">
                <div className="col-md-8 col-md-offset-2">
                    <SectionTitle>Регистрация</SectionTitle>

                    <p>Благодарим Ви за проявения интерес към нашето приложение. Ако искате да получите достъп до ранна
                        тестова версия на нашите медитации, моля попълнете формата на следния линк - <a
                            href="http://bit.ly/2DALdoI" target="_blank">http://bit.ly/2DALdoI</a>
                    </p>

                    <div className="text-center">
                        <h4 className="section-separator-text">или</h4>
                        <div className="cta-text">Вече имате акаунт?</div>
                        <div>
                            <Link to="/login" className="btn btn-default">Вход</Link>
                        </div>
                    </div>
                </div>
            </form>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(RegisterBetaPage);


// WEBPACK FOOTER //
// ./src/components/Pages/BetaRegister.js